import React, { Component } from 'react';
import './App.css';
import { connect } from 'react-redux';
import GCFMainApp from './components/GCFMainApp';
import LoginForm from './components/LoginForm';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import 'typeface-roboto';
import { logIn } from './store/actions/login/loginActions';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Page404 from './Page404';
import { getFrontendURL } from './Utils/ServerURL';
import { FONT_FAMILY_TYPOGRAPHY } from './Utils/Constants';

const deepPalette = createMuiTheme({
    palette: {
        primary: {
            main: "#0F3549",
            light: "#B9E9E9",
            // dark: "#73D2D2",
        },
        secondary: {
            main: "#ffffff"
        },
    },
    typography: FONT_FAMILY_TYPOGRAPHY
});

class App extends Component {

    homePage(props) {

        return (
            <div className='App'>
                {
                (!props.user.UserRoleType) ?
                    <LoginForm getUserRole={props.getUserRole} />
                    :
                    <GCFMainApp user={props.user} roleTypes={props.user.UserRoleType} ></GCFMainApp>
                }
            </div>
        )
    }

    render() {
        return (
            <MuiThemeProvider theme={deepPalette}>
                <Router basename={getFrontendURL()} >
                    <Switch>
                        <Route exact path="/"> {this.homePage(this.props)} </Route>

                        <Route exact path="/gcf/"> {this.homePage(this.props)} </Route>
                        
                        <Route path="*" component={Page404} ></Route>
                    </Switch>
                </Router>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
});

const mapDispatchToProps = dispatch => ({
    logIn: (sUsername, sPassword) => dispatch(logIn(sUsername, sPassword))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js